import script from "./InvoiceTransactionsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTransactionsRow.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceTransactionsRow.vue?vue&type=style&index=0&id=62433ccf&lang=css"

const __exports__ = script;

export default __exports__